import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <Container className="mt-4 mb-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Terms of Service</h2>
        <Button variant="outline-secondary" onClick={() => navigate(-1)}>
          ← Back
        </Button>
      </div>

      <Card>
        <Card.Body>
          <div className="mb-4">
            <p className="text-muted">
              <strong>Last updated:</strong> {new Date().toLocaleDateString()}
            </p>
          </div>

          <section className="mb-4">
            <h4>1. Acceptance of Terms</h4>
            <p>
              By accessing and using EWPulseSync ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section className="mb-4">
            <h4>2. Description of Service</h4>
            <p>
              EWPulseSync is a synchronization service that provides data management and integration capabilities. The service includes both free and premium subscription tiers with varying features and limitations.
            </p>
          </section>

          <section className="mb-4">
            <h4>3. User Accounts</h4>
            <p>
              To access certain features of the Service, you must register for an account. You are responsible for:
            </p>
            <ul>
              <li>Maintaining the confidentiality of your account credentials</li>
              <li>All activities that occur under your account</li>
              <li>Providing accurate and complete information during registration</li>
              <li>Updating your information to keep it current and accurate</li>
            </ul>
          </section>

          <section className="mb-4">
            <h4>4. Subscription and Billing</h4>
            <p>
              Our Service offers both free and paid subscription plans:
            </p>
            <ul>
              <li><strong>Free Plan:</strong> Limited features and usage</li>
              <li><strong>Premium Plans:</strong> Enhanced features and higher usage limits</li>
            </ul>
            <p>
              Subscription fees are billed in advance on a recurring basis. You may cancel your subscription at any time through your account settings or by contacting support.
            </p>
          </section>

          <section className="mb-4">
            <h4>5. Payment Terms</h4>
            <p>
              All payments are processed securely through Stripe. By subscribing to a paid plan, you agree to:
            </p>
            <ul>
              <li>Pay all fees associated with your chosen subscription plan</li>
              <li>Provide accurate billing information</li>
              <li>Authorize automatic billing for recurring subscriptions</li>
              <li>Notify us of any changes to your payment information</li>
            </ul>
          </section>

          <section className="mb-4">
            <h4>6. Refund Policy</h4>
            <p>
              We offer a 30-day money-back guarantee for new subscribers. Refunds are processed within 5-10 business days. To request a refund, please contact our support team.
            </p>
          </section>

          <section className="mb-4">
            <h4>7. Acceptable Use</h4>
            <p>
              You agree not to use the Service to:
            </p>
            <ul>
              <li>Violate any applicable laws or regulations</li>
              <li>Transmit or store malicious code or harmful content</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with or disrupt the Service</li>
              <li>Use the Service for any illegal or unauthorized purpose</li>
            </ul>
          </section>

          <section className="mb-4">
            <h4>8. Data and Privacy</h4>
            <p>
              Your privacy is important to us. Please review our Privacy Policy to understand how we collect, use, and protect your information. By using the Service, you consent to the collection and use of information as described in our Privacy Policy.
            </p>
          </section>

          <section className="mb-4">
            <h4>9. Intellectual Property</h4>
            <p>
              The Service and its original content, features, and functionality are owned by EWPulseSync and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
            </p>
          </section>

          <section className="mb-4">
            <h4>10. Service Availability</h4>
            <p>
              We strive to maintain high service availability but do not guarantee uninterrupted access. The Service may be temporarily unavailable due to maintenance, updates, or technical issues.
            </p>
          </section>

          <section className="mb-4">
            <h4>11. Limitation of Liability</h4>
            <p>
              To the maximum extent permitted by law, EWPulseSync shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.
            </p>
          </section>

          <section className="mb-4">
            <h4>12. Termination</h4>
            <p>
              We may terminate or suspend your account and access to the Service immediately, without prior notice, for any reason, including if you breach these Terms of Service.
            </p>
          </section>

          <section className="mb-4">
            <h4>13. Changes to Terms</h4>
            <p>
              We reserve the right to modify these terms at any time. We will notify users of any material changes via email or through the Service. Your continued use of the Service after such modifications constitutes acceptance of the updated terms.
            </p>
          </section>

          <section className="mb-4">
            <h4>14. Contact Information</h4>
            <p>
              If you have any questions about these Terms of Service, please contact us at:
            </p>
            <ul>
              <li>Email: support@ewpulsesync.com</li>
              <li>Website: https://pulsesync.bcntr.com</li>
            </ul>
          </section>

          <div className="mt-5 pt-4 border-top">
            <p className="text-muted small">
              By using EWPulseSync, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.
            </p>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default TermsOfService;
